<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Calculations'"
      :fields="[{ header: 'Name', prop: 'name' }, { header: 'Code', prop: 'code' }]"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"     
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'CalculationSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'calculation',
        editEntityScreen: 'Admin - Edit/View Calculation'
      }
    }
  }
</script>

<style scoped>
  .input-group input {
    border-radius: 30px 0 0 30px;
  }
  .input-group .input-group-addon {
    border-radius: 0 30px 30px 0;
  }
  .center-children-sm > * {
    border-radius: 0;
  }
  @media (max-width: 768px) {
    .center-children-sm > * {
      width:33%;
    }
  }
</style>



// WEBPACK FOOTER //
// CalculationSearchResults.vue?5c11137d